export default __webpack_public_path__ + "static/step-1-0de81cdec5031efce8c857b1513b8697.svg";